import { render, staticRenderFns } from "./postdoctorPaper.vue?vue&type=template&id=6e86d664&scoped=true&"
import script from "./postdoctorPaper.vue?vue&type=script&lang=js&"
export * from "./postdoctorPaper.vue?vue&type=script&lang=js&"
import style0 from "./postdoctorPaper.vue?vue&type=style&index=0&id=6e86d664&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e86d664",
  null
  
)

export default component.exports